import { render, staticRenderFns } from "./GleasonResultPanel.vue?vue&type=template&id=a11ca70a&scoped=true"
import script from "./GleasonResultPanel.vue?vue&type=script&lang=js"
export * from "./GleasonResultPanel.vue?vue&type=script&lang=js"
import style0 from "./GleasonResultPanel.vue?vue&type=style&index=0&id=a11ca70a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11ca70a",
  null
  
)

export default component.exports